import styled from 'styled-components';

export const Cards = styled.div`
  display: flex;
  width: 100%;

  > div,
  a > div {
    width: max-content;
    margin: 0 24px 0 0;
    display: flex;
    align-items: center;

    p {
      color: #fff;
      font-size: 24px;
      font-weight: bold;
    }

    img {
      margin-right: 12px;
      width: 34px;
      height: 24px;
      object-fit: contain;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    > div {
      width: 100%;
      padding: 12px 16px;
      margin-bottom: 24px;
    }
  }
`;

export const TableCard = styled.div`
  margin-top: 24px;
  width: calc(100% - 32px);

  @media screen and (max-width: 768px) {
    width: 100%;
    overflow: hidden;
    > div {
      overflow: auto;
    }
  }
`;

export const Form = styled.form`
  margin-top: 24px;
  width: calc(100% - 32px);

  .row {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: calc(50% - 32px);
      margin: 8px 16px;
    }
  }

  button {
    width: max-content;
    min-width: 200px;
    max-width: 100%;
    margin: 16px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    .row {
      > div {
        width: 100%;
        margin: 0;
      }
    }

    button {
      width: 100%;
      margin: 24px 0;
    }
  }
`;
